export default __webpack_public_path__ + "static/media/ThinkContract.af0fa0ea3329c4cc6d1e6c1ffb63bd53.webp";